import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  scrollToPricingSection,
  shouldScrollToPricing,
} from "../utils/scrollToPricing";
import { cancelScrollPageToTop } from "../utils/scrollPageToTop";

const usePricingScrollOnLoad = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!shouldScrollToPricing(location)) return;

    cancelScrollPageToTop();

    const timer = window.setTimeout(() => {
      scrollToPricingSection();
      navigate("/", {
        replace: true,
        state: null,
        preventScrollReset: true,
      });
    }, 100);

    return () => window.clearTimeout(timer);
  }, [location.state, location.pathname, navigate]);
};

export default usePricingScrollOnLoad;
